// extracted by mini-css-extract-plugin
module.exports = {"radio":"e336fd7528--radio--xGbrA","indicator":"e336fd7528--indicator--UVUda","label":"e336fd7528--label--ZoQ_y"};